import { render } from "./authV3.vue?vue&type=template&id=70315309&scoped=true"
import script from "./authV3.vue?vue&type=script&lang=js"
export * from "./authV3.vue?vue&type=script&lang=js"

import "./authV3.vue?vue&type=style&index=0&id=70315309&scoped=true&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70315309"]])

export default __exports__